module.exports = __webpack_public_path__ + "img/9791155715383.682c24a9.jpg";